module.exports = __webpack_public_path__ + "img/ch15_02_draft2.2ef37e30.png";